var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIconYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.311 12.53l3.453 1.338c.713.276 1.51.18 2.142-.262l7.357-5.128a.407.407 0 01.53.055.454.454 0 01-.01.634l-5.445 5.268a.73.73 0 00.051 1.087l5.75 4.564c1.037.823 2.537.189 2.736-1.156l2.001-13.51c.142-.952-.771-1.696-1.62-1.32L3.29 11.602a.5.5 0 00-.291.46c0 .207.124.394.311.466z",
    fill: "#F9B035"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIconYellow);
export default __webpack_public_path__ + "static/media/telegram-icon-yellow.9218cd42889943c17c6edd72ff9b947b.svg";
export { ForwardRef as ReactComponent };